import { render } from "./SignalLogsView.vue?vue&type=template&id=a5dd80fe"
import script from "./SignalLogsView.vue?vue&type=script&lang=js"
export * from "./SignalLogsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__